import { render, staticRenderFns } from "./BasicModal.vue?vue&type=template&id=f8ffd462&"
import script from "./BasicModal.vue?vue&type=script&lang=js&"
export * from "./BasicModal.vue?vue&type=script&lang=js&"
import style0 from "./BasicModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8ffd462')) {
      api.createRecord('f8ffd462', component.options)
    } else {
      api.reload('f8ffd462', component.options)
    }
    module.hot.accept("./BasicModal.vue?vue&type=template&id=f8ffd462&", function () {
      api.rerender('f8ffd462', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BasicModal.vue"
export default component.exports